export const GTM_ID = process.env.PUBLIC_GOOGLE_TAG_MANAGER_ID;

export const pageView = (url) => {
  window.dataLayer.push({
    event: 'pageview',
    page: url,
  });
};
